fragment MeetingValidityIssueFragment on MeetingValidityIssue {
    user {
        id
        name
    }
    issueType
}
